/* Ecochic en Eurus — portado de web-v3/js/pdf.js (FLUJO_FRONTEND_ECOCHIC_v1 §6, §9, §10). Solo navegador (fase 1). */
/* pdf.js — window.EcoPDF: generación de PDF client-side con identidad Ecochic.
   ───────────────────────────────────────────────────────────────────────────
   FILOSOFÍA
   - Todo se genera EN EL NAVEGADOR (jsPDF por CDN, carga perezosa solo al usar).
     Nada se sube a ningún servidor (los PDF de cliente contienen dato de salud).
   - Identidad de marca compartida: logo real de assets/brand, paleta monocroma
     real (#2B2B2B sobre blanco), cabecera/pie coherentes, nº de página y claim.
     TODOS los PDF deben construirse con EcoPDF para que la identidad sea única.
   - Defensivo: si jsPDF/CDN o una imagen no cargan, no se rompe la app; el PDF
     se genera sin esa pieza (degradación declarada) o el llamador captura el error.

   DEPENDENCIAS (CDN, cargadas bajo demanda):
   - jsPDF UMD 2.5.x  → window.jspdf.jsPDF
   - html2canvas 1.4.x (opcional, solo si se rasteriza DOM) → window.html2canvas

   CONTRATO (todo bajo window.EcoPDF):
     EcoPDF.available()                  -> bool (hay entorno para generar)
     EcoPDF.brand                        -> {ink,soft,line,muted,bg2,claim,font}
     EcoPDF.ensure()                     -> Promise<jsPDF ctor>   (carga jsPDF)
     EcoPDF.ensureHtml2canvas()          -> Promise<fn>
     EcoPDF.imageToDataURL(url)          -> Promise<dataURL|null> (CORS-safe; null si falla)
     EcoPDF.create({title,subtitle,meta})-> Promise<Doc>          (documento listo, 1ª pág con cabecera)

   Doc (wrapper sobre jsPDF; gestiona cursor + salto de página + cabecera/pie):
     .heading(text[,opts])      título de sección (regla inferior)
     .h2(text)                  subtítulo
     .paragraph(text[,opts])    párrafo con ajuste de línea
     .kv(label,value)           fila etiqueta/valor
     .chips(label,arr)          etiqueta + lista de valores en línea
     .bullets(arr)              lista con viñetas
     .image(dataURL,{w,h,caption,frame}) imagen centrada con pie opcional (omite si null)
     .placeholder(text)         caja gris "sin imagen disponible" (cae aquí si no hay molécula/foto)
     .refs(arr)                 referencias citadas (cita + enlace; NO reproduce el paper)
     .note(text)               nota pequeña (deuda/atribución/aviso)
     .rule()                    línea divisoria
     .spacer(h)                 espacio vertical
     .pageBreak()               fuerza nueva página
     .ensureSpace(h)            salta de página si no caben h pt
     .save(filename)            pagina pies, descarga el archivo
     .doc                       jsPDF crudo por si se necesita algo a medida
   ─────────────────────────────────────────────────────────────────────────── */
(function(){
  "use strict";
  /* jsPDF se sirve LOCAL desde el repo (js/vendor/jspdf.umd.min.js), cargado por <script> en
     index.html ANTES que este fichero. Así NO dependemos de ningún CDN externo (la causa real del
     fallo era un 404 del CDN: la versión 2.5.2 no existía en cdnjs). Mantenemos un fallback que
     reinyecta el MISMO fichero local (mismo origen) por si el <script> no estuviera presente. */
  var JSPDF_LOCAL=(window.ECO_ASSETS&&ECO_ASSETS.jspdf)||'jspdf.umd.min.js';
  var H2C_CDN='https://cdnjs.cloudflare.com/ajax/libs/html2canvas/1.4.1/html2canvas.min.js'; // opcional; hoy NO se usa en la generación
  var LOGO_URL=(window.ECO_ASSETS&&ECO_ASSETS.logo)||'';
  var IMG_TIMEOUT=7000; // ms: si una imagen no carga (CORS/timeout), se degrada a "sin imagen"

  var BRAND={ ink:'#2B2B2B', soft:'#5a5a57', line:'#e6e6e2', muted:'#8f8f8a',
    bg2:'#f6f6f4', claim:EcoT('pdf.cosmetica_clean_curada_por_evidencia'),
    /* DM Sans no se embebe en el PDF (la fuente TTF en base64 pesaría de más);
       usamos helvetica (sans limpia) + layout/monocromo/logo para la identidad. */
    font:'helvetica' };

  /* ---------- carga perezosa de scripts CDN ---------- */
  var _cache={};
  function loadScript(src){
    if(_cache[src]) return _cache[src];
    _cache[src]=new Promise(function(res,rej){
      try{
        var s=document.createElement('script'); s.src=src; s.async=true;
        s.onload=function(){ res(true); };
        s.onerror=function(){ rej(new Error(EcoT('pdf.no_se_pudo_cargar')+' '+src)); };
        document.head.appendChild(s);
      }catch(e){ rej(e); }
    });
    return _cache[src];
  }
  function jsPDFctor(){ return (window.jspdf&&window.jspdf.jsPDF)||window.jsPDF||null; }

  function ensure(){
    var c=jsPDFctor(); if(c) return Promise.resolve(c); // ya cargado por el <script> local de index.html
    // fallback: reinyecta el mismo fichero local (mismo origen, sin red externa)
    return loadScript(JSPDF_LOCAL).then(function(){
      var k=jsPDFctor(); if(!k) throw new Error(EcoT('pdf.no_se_pudo_inicializar_jspdf_js_vendor')); return k;
    });
  }
  function ensureHtml2canvas(){
    if(window.html2canvas) return Promise.resolve(window.html2canvas);
    return loadScript(H2C_CDN).then(function(){ return window.html2canvas; });
  }

  /* ---------- imagen → dataURL (CORS-safe; null si falla, nunca lanza) ---------- */
  var _imgCache={};
  function imageToDataURL(url){
    if(!url) return Promise.resolve(null);
    if(_imgCache[url]!==undefined) return Promise.resolve(_imgCache[url]);
    return new Promise(function(res){
      var done=false; var timer=null;
      function finish(v){ if(done) return; done=true; if(timer){ clearTimeout(timer); } _imgCache[url]=v; res(v); }
      try{
        var img=new Image();
        // crossOrigin solo para http(s) remotos; los assets locales no lo necesitan
        if(/^https?:/i.test(url)) img.crossOrigin='anonymous';
        // timeout: si la imagen cuelga (CORS/red), degradamos a "sin imagen" y NO bloqueamos el PDF
        timer=setTimeout(function(){ finish(null); }, IMG_TIMEOUT);
        img.onload=function(){
          try{
            var c=document.createElement('canvas'); c.width=img.naturalWidth||img.width; c.height=img.naturalHeight||img.height;
            c.getContext('2d').drawImage(img,0,0);
            finish(c.toDataURL('image/png'));
          }catch(e){ finish(null); } // canvas "tainted" (sin CORS) → sin imagen
        };
        img.onerror=function(){ finish(null); };
        img.src=url;
      }catch(e){ finish(null); }
    });
  }

  /* ---------- utilidades de color/texto ---------- */
  function hex(h){ h=String(h||'#000').replace('#',''); if(h.length===3) h=h[0]+h[0]+h[1]+h[1]+h[2]+h[2];
    return { r:parseInt(h.slice(0,2),16)||0, g:parseInt(h.slice(2,4),16)||0, b:parseInt(h.slice(4,6),16)||0 }; }

  /* ---------- Doc: wrapper sobre jsPDF ---------- */
  function makeDoc(JsPDF, logoData, opts){
    opts=opts||{};
    var doc=new JsPDF({unit:'pt', format:'a4', compress:true});
    var PW=doc.internal.pageSize.getWidth();      // ~595
    var PH=doc.internal.pageSize.getHeight();     // ~842
    var M=48;                                      // margen
    var CW=PW-M*2;                                 // ancho de contenido
    var TOP=92;                                    // y inicial bajo cabecera
    var BOTTOM=PH-56;                              // límite inferior antes del pie
    var y=TOP;
    var ink=hex(BRAND.ink), soft=hex(BRAND.soft), line=hex(BRAND.line), muted=hex(BRAND.muted);

    function setColor(c){ doc.setTextColor(c.r,c.g,c.b); }
    function font(style,size){ doc.setFont(BRAND.font,style||'normal'); doc.setFontSize(size||11); }

    function header(){
      // logo (proporción real ~5:1) o wordmark de respaldo
      if(logoData){ try{ doc.addImage(logoData,'PNG',M,30,120,24); }catch(e){ wordmark(); } }
      else wordmark();
      // claim / eyebrow a la derecha
      font('normal',8); setColor(muted);
      doc.text((opts.eyebrow||BRAND.claim).toUpperCase(), PW-M, 44, {align:'right'});
      // regla inferior de cabecera
      doc.setDrawColor(line.r,line.g,line.b); doc.setLineWidth(0.8); doc.line(M,64,PW-M,64);
    }
    function wordmark(){ font('bold',15); setColor(ink); doc.text(EcoT('pdf.ecochic'),M,50); }

    function footer(pageNum,total){
      doc.setDrawColor(line.r,line.g,line.b); doc.setLineWidth(0.8); doc.line(M,PH-44,PW-M,PH-44);
      font('normal',7.5); setColor(muted);
      doc.text(EcoT('pdf.documento_ecochic_generado_en_tu_naveg')+(opts.dateStr?(' · '+opts.dateStr):''), M, PH-30);
      doc.text(EcoT('pdf.pag')+' '+pageNum+(total?(' / '+total):''), PW-M, PH-30, {align:'right'});
    }

    function newPage(){ doc.addPage(); y=TOP; header(); }
    function ensureSpace(h){ if(y+(h||0)>BOTTOM) newPage(); }

    var api={
      doc:doc, brand:BRAND,
      get y(){ return y; }, set y(v){ y=v; },
      spacer:function(h){ y+=(h||10); return api; },
      rule:function(){ ensureSpace(14); doc.setDrawColor(line.r,line.g,line.b); doc.setLineWidth(0.6); doc.line(M,y,PW-M,y); y+=14; return api; },
      pageBreak:function(){ newPage(); return api; },
      ensureSpace:ensureSpace,

      title:function(text,sub){ // título principal del documento (1ª pág)
        font('bold',22); setColor(ink); ensureSpace(30);
        var lines=doc.splitTextToSize(String(text||''),CW); doc.text(lines,M,y); y+=lines.length*24;
        if(sub){ font('normal',11); setColor(soft); var s=doc.splitTextToSize(String(sub),CW); doc.text(s,M,y); y+=s.length*15+4; }
        y+=6; return api;
      },
      heading:function(text){ ensureSpace(30); font('bold',13); setColor(ink);
        doc.text(String(text||''),M,y); y+=8;
        doc.setDrawColor(line.r,line.g,line.b); doc.setLineWidth(0.8); doc.line(M,y,PW-M,y); y+=14; return api; },
      h2:function(text){ ensureSpace(20); font('bold',11); setColor(ink); doc.text(String(text||''),M,y); y+=15; return api; },
      paragraph:function(text,o){ o=o||{}; if(text==null||text==='') return api;
        font(o.bold?'bold':'normal', o.size||10.5); setColor(o.muted?muted:soft);
        var lines=doc.splitTextToSize(String(text),CW); var lh=(o.size||10.5)*1.4;
        for(var i=0;i<lines.length;i++){ ensureSpace(lh); doc.text(lines[i],M,y); y+=lh; }
        y+=4; return api; },
      kv:function(label,value){ ensureSpace(16); font('bold',9.5); setColor(muted);
        doc.text(String(label||'').toUpperCase(),M,y);
        font('normal',10.5); setColor(ink);
        var lines=doc.splitTextToSize(String(value==null||value===''?'—':value),CW-130);
        for(var i=0;i<lines.length;i++){ if(i>0) ensureSpace(14); doc.text(lines[i],M+130,y); if(i<lines.length-1) y+=14; }
        y+=16; return api; },
      chips:function(label,arr){ var a=(arr||[]).filter(Boolean);
        if(label){ font('bold',9.5); setColor(muted); ensureSpace(15); doc.text(String(label).toUpperCase(),M,y); y+=14; }
        if(!a.length){ font('normal',10); setColor(muted); doc.text('—',M,y); y+=16; return api; }
        font('normal',9.5); var x=M; var gap=8, padX=8, h=18;
        for(var i=0;i<a.length;i++){ var t=String(a[i]); var w=doc.getTextWidth(t)+padX*2;
          if(x+w>PW-M){ x=M; y+=h+6; ensureSpace(h+6); }
          doc.setDrawColor(line.r,line.g,line.b); doc.setFillColor(246,246,244); doc.setLineWidth(0.6);
          doc.roundedRect(x,y-12,w,h,9,9,'FD'); setColor(ink); doc.text(t,x+padX,y+1); x+=w+gap; }
        y+=h+4; return api; },
      bullets:function(arr){ var a=(arr||[]).filter(Boolean); font('normal',10.5); setColor(soft);
        for(var i=0;i<a.length;i++){ var lines=doc.splitTextToSize(String(a[i]),CW-16);
          for(var j=0;j<lines.length;j++){ ensureSpace(15); if(j===0){ setColor(ink); doc.text('·',M,y); setColor(soft);} doc.text(lines[j],M+14,y); y+=15; } }
        y+=4; return api; },
      image:function(dataURL,o){ o=o||{};
        if(!dataURL){ return o.placeholder!==false ? api.placeholder(o.caption||EcoT('pdf.sin_imagen_de_fuente_libre_disponible')) : api; }
        var w=o.w||220, h=o.h||w; ensureSpace(h+(o.caption?20:8)+8);
        var x=o.align==='left'? M : (PW-w)/2;
        if(o.frame!==false){ doc.setDrawColor(line.r,line.g,line.b); doc.setFillColor(255,255,255); doc.setLineWidth(0.8); doc.roundedRect(x-8,y-8,w+16,h+16,6,6,'S'); }
        try{ doc.addImage(dataURL,'PNG',x,y,w,h); }catch(e){ return api.placeholder(o.caption||EcoT('pdf.imagen_no_incrustable')); }
        y+=h+8;
        if(o.caption){ font('normal',8.5); setColor(muted); var cl=doc.splitTextToSize(String(o.caption),CW);
          for(var i=0;i<cl.length;i++){ ensureSpace(12); doc.text(cl[i],PW/2,y,{align:'center'}); y+=12; } }
        y+=6; return api; },
      placeholder:function(text){ var h=110; ensureSpace(h+8); var w=220, x=(PW-w)/2;
        doc.setDrawColor(line.r,line.g,line.b); doc.setFillColor(246,246,244); doc.setLineWidth(0.8);
        doc.roundedRect(x,y,w,h,6,6,'FD'); font('normal',9); setColor(muted);
        var t=doc.splitTextToSize(String(text||EcoT('pdf.sin_imagen_disponible')),w-24); doc.text(t,x+w/2,y+h/2,{align:'center',baseline:'middle'});
        y+=h+12; return api; },
      refs:function(arr){ var a=(arr||[]).filter(function(r){return r&&(r.cita||r.url);});
        if(!a.length){ return api.note(EcoT('pdf.referencias_en_revision')); }
        for(var i=0;i<a.length;i++){ var r=a[i];
          font('normal',8.5); setColor(soft);
          var cite=doc.splitTextToSize((i+1)+'. '+String(r.cita||r.url),CW);
          for(var j=0;j<cite.length;j++){ ensureSpace(12); doc.text(cite[j],M,y); y+=12; }
          if(r.url){ font('normal',8.5); setColor(ink); ensureSpace(12);
            doc.textWithLink(String(r.url),M+10,y,{url:String(r.url)}); y+=14; } else y+=2;
        }
        y+=2; return api; },
      note:function(text){ if(!text) return api; font('italic',8.5); setColor(muted);
        var lines=doc.splitTextToSize(String(text),CW); for(var i=0;i<lines.length;i++){ ensureSpace(12); doc.text(lines[i],M,y); y+=12; } y+=4; return api; },

      save:function(filename){
        // pies con numeración total
        var total=doc.internal.getNumberOfPages();
        for(var p=1;p<=total;p++){ doc.setPage(p); footer(p,total); }
        try{ doc.save(filename||'ecochic.pdf'); }catch(e){ /* sin entorno de descarga */ }
        return api;
      }
    };

    header(); // primera página
    return api;
  }

  function create(opts){
    opts=opts||{};
    if(!opts.dateStr){ try{ opts.dateStr=new Date().toLocaleDateString('es-ES'); }catch(e){} }
    return ensure().then(function(JsPDF){
      return imageToDataURL(LOGO_URL).then(function(logo){
        var d=makeDoc(JsPDF,logo,opts);
        if(opts.title) d.title(opts.title,opts.subtitle);
        return d;
      });
    });
  }

  window.EcoPDF={
    available:function(){ return typeof document!=='undefined' && typeof Image!=='undefined'; },
    brand:BRAND,
    ensure:ensure,
    ensureHtml2canvas:ensureHtml2canvas,
    imageToDataURL:imageToDataURL,
    create:create
  };
})();
